var map = {
	"./appointment-icon.svg": 72724,
	"./calendar-clock.svg": 33204,
	"./cardIcon.svg": 8598,
	"./circle-euro-to-slot-solid.svg": 68538,
	"./doctor.svg": 49730,
	"./euro-circle-check-solid.svg": 2516,
	"./euro.svg": 8676,
	"./eye-closed.svg": 4315,
	"./file-circle-euro-solid.svg": 30194,
	"./fromhome.svg": 80862,
	"./fromoffice.svg": 40807,
	"./hands-holding-euro-primary.svg": 34628,
	"./hands-holding-euro.svg": 38761,
	"./hospital-buildings.svg": 84513,
	"./hospital.svg": 64365,
	"./location-icon.png": 97110,
	"./location-icon.svg": 98824,
	"./logo.svg": 96522,
	"./pincode.svg": 56167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53527;